import React from "react";
import "../../Styles/yellowcalf.css/Transaction_Failed.css"; // new CSS file

function Transaction_Failed() {
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="tf-panel" style={{paddingTop:"25px"}}>
      <div className="tf-message-box">
        <h2 className="tf-title">Transaction Failed!</h2>

        <svg
          className="tf-cross-svg"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 52 52"
          width="100"
          height="100"
        >
          <circle className="tf-cross-circle" cx="26" cy="26" r="25" fill="none"></circle>
          <path className="tf-cross-line" d="M16,16 l20,20"></path>
          <path className="tf-cross-line" d="M16,36 l20,-20"></path>
        </svg>
      </div>

      <table className="tf-table">
        <tbody>
          <tr>
            <td>Response Message</td>
            <td><code>Payment Failed</code></td>
          </tr>
          <tr>
            <td>Transaction Id</td>
            <td><code>1607F616</code></td>
          </tr>
          <tr>
            <td>Student Name</td>
            <td><code>Neha Pethkar</code></td>
          </tr>
          <tr>
            <td>Amount</td>
            <td><code>USD 552.4</code></td>
          </tr>
          <tr>
            <td>Payment Option</td>
            <td><code>Paypal</code></td>
          </tr>
          <tr>
            <td>Payment Error</td>
            <td><code>Network Timeout</code></td>
          </tr>
        </tbody>
      </table>

      <div className="tf-btn-container">
        <button className="tf-print-btn">Print</button>
      </div>
    </div>
  );
}

export default Transaction_Failed;
